/**
 * File mypay-eligiblity.js.
 * Handles MyPay eligibility modal behavior
 */

const myPayEligibilityModal = document.querySelector('.mypay-eligibility__modal');
const myPayModalEligibilityBtn = document.querySelector('.mypay-eligibility__modal .mypay-eligibility__modal-content-btn');
const myPayEligibilityLinks = document.querySelectorAll('.mypay-eligibility__content');

function enableMyPayEligibilityLinks() {
  myPayEligibilityLinks.forEach((myPayEligibilityLink) => { 
    const myPayEligibilityModal = myPayEligibilityLink.parentElement.nextSibling;
    const myPayModalEligibilityBtn = myPayEligibilityModal.querySelector('.mypay-eligibility__modal-content-btn');
    myPayEligibilityLink.addEventListener('click', function () {
      showModal(myPayEligibilityModal);
    });
    if (myPayModalEligibilityBtn) myPayModalEligibilityBtn.addEventListener('click', function () { hideModal(myPayEligibilityModal); });
  });
}

// Inits
enableMyPayEligibilityLinks();
